var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _HealthCentre;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, belongsTo, hasMany, SyncHasMany } from "@ember-data/model";
import CompoundSurvey from "compound-survey/models/compound-survey";
import PrescriptionConfiguration from "core/models//prescription-configuration";
import DmpHealthCentreConfig from "core/models/dmp-health-centre-config";
import LearningSection from "core/models/learning-section";
import Patient from "core/models/patient";
import { sortBy } from "core/utils/sort";
import CareGiver from "./care-giver";
import HealthCentreTag from "./health-centre-tag";
let HealthCentre = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("string"), _dec6 = attr("boolean"), _dec7 = attr("boolean"), _dec8 = attr("boolean"), _dec9 = attr("boolean"), _dec10 = attr("boolean"), _dec11 = attr("boolean"), _dec12 = attr("string"), _dec13 = attr("boolean"), _dec14 = attr("boolean"), _dec15 = attr("boolean"), _dec16 = attr("boolean"), _dec17 = attr("boolean"), _dec18 = attr("boolean"), _dec19 = attr("boolean"), _dec20 = attr("boolean"), _dec21 = belongsTo("dmp-health-centre-config", {
  async: false,
  inverse: "healthCentre"
}), _dec22 = hasMany("health-centre-tag", {
  async: false,
  inverse: "healthCentres"
}), _dec23 = hasMany("patient", {
  async: false,
  inverse: "healthCentre"
}), _dec24 = hasMany("learning-section", {
  async: false,
  inverse: "healthCentre"
}), _dec25 = hasMany("compound-survey", {
  async: false,
  inverse: "healthCentres"
}), _dec26 = belongsTo("prescription-configuration", {
  async: false,
  inverse: "healthCentre"
}), _dec27 = hasMany("care-giver", {
  async: false,
  inverse: "healthCentre"
}), _class = (_HealthCentre = class HealthCentre extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "finess", _descriptor, this);
    _initializerDefineProperty(this, "code", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "productName", _descriptor4, this);
    _initializerDefineProperty(this, "service", _descriptor5, this);
    _initializerDefineProperty(this, "hasRestrictedMessaging", _descriptor6, this);
    _initializerDefineProperty(this, "isgt", _descriptor7, this);
    _initializerDefineProperty(this, "oncoToulouse", _descriptor8, this);
    _initializerDefineProperty(this, "proIrc", _descriptor9, this);
    _initializerDefineProperty(this, "healthCentrePatientSearch", _descriptor10, this);
    _initializerDefineProperty(this, "isMrcBordeaux", _descriptor11, this);
    _initializerDefineProperty(this, "uuid", _descriptor12, this);
    _initializerDefineProperty(this, "isPartOfIdentificationDomain", _descriptor13, this);
    /** A flag to activate the -pre-transplant folder feature for this health centre */
    _initializerDefineProperty(this, "preTransplant", _descriptor14, this);
    /** A flag to activate the new patient-history dashboard */
    _initializerDefineProperty(this, "patientHistoryDashboardEnabled", _descriptor15, this);
    /** A flag to activate for DigestWise patients if they are in the control group */
    _initializerDefineProperty(this, "controlGroupCentre", _descriptor16, this);
    /** A flag to deactivate the posibility for patient to decalre some bio results */
    _initializerDefineProperty(this, "disableBioForPatient", _descriptor17, this);
    /** A flag to deactivate the teleconsultation */
    _initializerDefineProperty(this, "teleconsultationDisabled", _descriptor18, this);
    /** A flag to activate daily call to profiler */
    _initializerDefineProperty(this, "enableProfilerV2", _descriptor19, this);
    /** A flag to activate the toucan dashboard */
    _initializerDefineProperty(this, "toucanEnabled", _descriptor20, this);
    _initializerDefineProperty(this, "dmpHealthCentreConfig", _descriptor21, this);
    _initializerDefineProperty(this, "healthCentreTags", _descriptor22, this);
    _initializerDefineProperty(this, "patients", _descriptor23, this);
    _initializerDefineProperty(this, "learningSections", _descriptor24, this);
    _initializerDefineProperty(this, "surveys", _descriptor25, this);
    _initializerDefineProperty(this, "prescriptionConfiguration", _descriptor26, this);
    _initializerDefineProperty(this, "careGivers", _descriptor27, this);
  }
  get orderedLearningSections() {
    //@ts-expect-error TODO: update the learningSections type when @types/ember-data will be updated
    return this.learningSections.toSorted(sortBy("position"));
  }
  get shouldShowHlaContent() {
    const hlaUUIDHealthCentres = ["a9a0599c-2864-40d3-a98f-4d2137966386",
    // Hôpital Bicêtre AP-HP
    "f38415fb-c2a5-4ac2-a1a8-221be175c13e",
    // Necker Adultes
    "78024f08-8642-4584-a927-ec75f0bcae55",
    // APHP - La Pitié Salpêtrière
    "f0895652-6bf6-447a-b67f-805a7cc77f21",
    // CH RENE DUBOS - Pontoise
    "51f1ccc8-3417-4d09-9e32-47a151a48cde",
    // Hôpital Européen Georges-Pompidou
    "ce022ac5-3cb9-4e10-a520-a397741f0bf3" // Hôpital Foch
    ];
    return hlaUUIDHealthCentres.includes(this.uuid) && this.service === "renal";
  }

  // Try to find a TherapeuticalArea record from the `service` attribte,
  // either by mapping the service to its corresponding therapeuticalArea Id
  // or just with the service name
  get therapeuticalArea() {
    const areaId = HealthCentre.serviceToTherapeuticalAreaId[this.service] ?? this.service;
    return areaId ? this.store.peekRecord("therapeutical-area", areaId) : null;
  }
  get productNameCapitalized() {
    return this.productName.replace(/^(.*?)(wise)$/, (_match, p1, p2) => p1.charAt(0).toUpperCase() + p1.slice(1) + p2.charAt(0).toUpperCase() + p2.slice(1));
  }
}, _defineProperty(_HealthCentre, "serviceToTherapeuticalAreaId", {
  renal: "nephro",
  pulmonary: "pneumo",
  rheumatology: "rhumato",
  cancer: "onco",
  psychiatry: "mental",
  hepatology: "hepato",
  cardiology: "cardio",
  diabetology: "diabeto",
  gastroenterology: "digest",
  generic: "generic"
}), _HealthCentre), _descriptor = _applyDecoratedDescriptor(_class.prototype, "finess", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "code", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "productName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "service", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasRestrictedMessaging", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isgt", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "oncoToulouse", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "proIrc", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "healthCentrePatientSearch", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isMrcBordeaux", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "uuid", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "isPartOfIdentificationDomain", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "preTransplant", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "patientHistoryDashboardEnabled", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "controlGroupCentre", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "disableBioForPatient", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "teleconsultationDisabled", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "enableProfilerV2", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "toucanEnabled", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "dmpHealthCentreConfig", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "healthCentreTags", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "patients", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "learningSections", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "surveys", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "prescriptionConfiguration", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "careGivers", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { HealthCentre as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.